import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onBeforeUnmount } from 'vue'
import { ConnectHTMLElementRecord, loadConnectAndInitialize } from '@stripe/connect-js'
import type { StripeConnectInstance } from '@stripe/connect-js'
import { mdiClose } from '@mdi/js'

interface Emits {
  (e: 'input', value: boolean): void
  (e: 'complete'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StripeOnboardingModal',
  props: {
  value: {
    type: Boolean,
    required: true,
  },
  clientSecret: {
    type: String,
    default: null,
  },
},
  emits: ["input", "complete"],
  setup(__props, { emit }: { emit: ({
  (e: 'input', value: boolean): void
  (e: 'complete'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const STRIPE_PUBLISHABLE_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY!




const isLoading = ref(false)
const stripeContainer = ref<HTMLElement | null>(null)
let stripeInstance: StripeConnectInstance | null = null
let onboardingComponent: ConnectHTMLElementRecord['account-onboarding'] | null = null

const handleOnboardingComplete = () => {
  emit('complete')
  emit('input', false)
}

const handleClose = () => {
  emit('input', false)
}

const cleanup = () => {
  if (onboardingComponent) {
    onboardingComponent.remove()
    onboardingComponent = null
  }
  stripeInstance = null
}

const initializeStripe = async (clientSecret: string) => {
  cleanup()
  isLoading.value = true

  try {
    stripeInstance = loadConnectAndInitialize({
      publishableKey: STRIPE_PUBLISHABLE_KEY,
      fetchClientSecret: async () => clientSecret,
      appearance: {
        overlays: 'dialog',
        variables: {
          colorPrimary: '#6366f1',
          colorBackground: '#ffffff',
          fontFamily: 'Roboto, sans-serif',
          borderRadius: '8px',
        },
      },
    })

    isLoading.value = false

    if (stripeContainer.value) {
      onboardingComponent = stripeInstance.create('account-onboarding')
      onboardingComponent.setOnExit(handleOnboardingComplete)
      stripeContainer.value.appendChild(onboardingComponent)
    }
  } catch (error) {
    console.error('Failed to initialize Stripe Connect:', error)
    isLoading.value = false
  }
}

// Initialize Stripe when modal opens with clientSecret
watch(
  () => props.value,
  async (isOpen) => {
    if (isOpen && props.clientSecret) {
      await initializeStripe(props.clientSecret)
    } else if (!isOpen) {
      cleanup()
    }
  }
)

// Cleanup on unmount
onBeforeUnmount(cleanup)

return { __sfc: true,STRIPE_PUBLISHABLE_KEY, props, emit, isLoading, stripeContainer, stripeInstance, onboardingComponent, handleOnboardingComplete, handleClose, cleanup, initializeStripe, mdiClose }
}

})